<template>
  <div class="viedo-upload">
    <!-- 视频上传组件测试 -->
    <div class="video-top">
      <div class="video-show" v-if="videoCover">
        <!-- <img class="avatar" :src="videoCover"> -->
        <el-image class="avatar" :src="videoCover">
          <el-image slot="error" :src="no_pic"></el-image>
        </el-image>
        <div class="video-mask">
          <span class="del-btn" @click="handleDel">
            <i class="el-icon-close"></i>
          </span>
          <span class="preview-btn" @click="handlePreview">
            <i class="el-icon-ai44"></i>
          </span>
          <span class="play-btn" @click="handlePlay">
            <i class="el-icon-video-play"></i>
          </span>
        </div>
      </div>
      <el-upload
        v-else
        ref="upload"
        class="avatar-uploader"
        action="#"
        :auto-upload="false"
        :accept="limitSuffix"
        :show-file-list="false"
        :before-upload="beforeUpload"
        :on-change="handleChanges"
        :multiple="false"
        :drag="true"
      >
        <div class="avatar-uploader-icon" slot="default">
          <template v-if="uploading">
            <i class="el-icon-loading"></i>
            <span class="upload-text">上传中</span>
          </template>
          <i v-else class="el-icon-video-camera"></i>
        </div>
      </el-upload>
    </div>
    <span v-if="aspectRatioText" style="font-size: 12px">{{ aspectRatioText }}</span>

    <el-dialog title="视频" :visible.sync="showPlayVideo" :showFullscreen="true" width="60%" @close="closeDialog">
      <video controls autoplay style="height: 100%; width: 100%">
        <source :src="videoUrl" />
      </video>
    </el-dialog>
  </div>
</template>
<script>
import OSSClient from '@components/Uploads/OSS-client';
import no_pic from '@/assets/images/no_pic.png';

// OSS 封面图截取参数
const oss_cover_search_params = 'x-oss-process=video/snapshot,t_0,f_jpg';

export default {
  props: {
    video: {
      // 回显内容
      type: Object,
      default: null,
    },
    aspectRatio: {
      // 限制长宽比 width/height
      type: String,
      default: '',
    },
    aspectRatioText: {
      // 长宽比文案
      type: String,
      default: '',
    },
    limitSuffix: {
      // 格式
      type: String,
      default: '.mp4, .mov, .m4v, .flv, .x-flv, .mkv, .wmv, .rmvb, .rm, .3gp, .avi',
    },
    limitWidth: {
      // 限制宽度
      type: Array,
      default() {
        // 0表示不限制
        return [0, 0];
      },
    },
    limitHeight: {
      // 限制高度
      type: Array,
      default() {
        // 0表示不限制
        return [0, 0];
      },
    },
    limitDuration: {  // 视频时长
      type: [String, Number],
      default: '',
    },
    limitTitle: {
      type: Number,
      default: 20,
    }
  },
  data() {
    return {
      videoUrl: '',
      videoCover: '',
      uploading: false,
      errmsg: '',
      fileList: '',
      showPlayVideo: false,
      aspectRatioList: [],
      aspectRatioResultList: [],
      aspectRatioResult: 0,
      no_pic,
    };
  },
  watch: {
    video: {
      handler(v) {
        if (v) {
          this.videoUrl = v.originUrl;
          this.videoCover = v.videoCover ? v.videoCover : `${v.originUrl}?${oss_cover_search_params}`;
        }
      },
      deep: true,
      immediate: true,
    },
    aspectRatio: {
      handler(v) {
        if (v) {
          this.aspectRatioList = this.aspectRatio.split(',');
          this.aspectRatioResultList = this.aspectRatioList.map(ratioStr => {
            let parts = ratioStr.split(':'); // 将字符串按冒号分隔成两部分
            let numerator = parseInt(parts[0]); // 将第一部分转换为整数
            let denominator = parseInt(parts[1]); // 将第二部分转换为整数
            return this.roundNumber(numerator / denominator, 1); // 计算结果保留一位小数点
          });
        }
      },
      immediate: true,
    },
    
  },
  methods: {
    async handleChanges(file) {
      const limitRes = await this._file_limit(file.raw);
      // 说明效验通过
      if (limitRes.success) {
        this.errmsg = '';
        this.fileList = [file];
        this.$refs.upload?.submit(); // 手动打开upload的上传行为，就可以触发 before-upload事件了
      } else {
        this.$refs.upload?.clearFiles(); // 清空已上传的列表
        return this.$message.error(limitRes.errmsg);
      }
    },
    // 视频效验
    _file_limit(file) {
      return new Promise((resolve, reject) => {
        // 视频文件格式校验
        const isType = [
          'video/mp4',
          'video/quicktime',
          'video/m4v',
          'video/flv',
          'video/x-flv',
          'video/x-ms-wmv',
          'application/vnd.rn-realmedia',
          'video/3gpp',
          'video/avi',
        ].includes(file.type);
        if (!isType) {
          resolve({ errmsg: '视频格式错误' });
        }
        // 视频文件宽高比效验
        let _videoElement = document.createElement('video');
        _videoElement.addEventListener('loadedmetadata', () => {
          const minWidth = this.limitWidth[0];
          const maxWidth = this.limitWidth[1];
          const minHeight = this.limitHeight[0];
          const maxHeight = this.limitHeight[1];
          const videoWidth = _videoElement.videoWidth;
          const videoHeight = _videoElement.videoHeight;
          console.log(videoWidth,videoHeight, _videoElement, '---videoWidth,videoHeight, _videoElement-')

          if (this.aspectRatio && videoWidth && videoHeight) {
            const aspectRatio = this.roundNumber(videoWidth / videoHeight, 1);
            if (this.aspectRatioResultList.includes(aspectRatio)) {
              this.aspectRatioResult = this.aspectRatioList[this.aspectRatioResultList.indexOf(aspectRatio)]
              return resolve({ success: true });
            } else {
              return resolve({ errmsg: `视频宽高比限制为${this.aspectRatio}` });
            }
          }
          if (minWidth || minHeight || maxHeight || maxWidth) {
            if (maxWidth && videoWidth > maxWidth) {
              return resolve({ errmsg: '宽度不能大于' + maxWidth });
            } else if (maxHeight && videoHeight > maxHeight) {
              return resolve({ errmsg: '高度不能大于' + maxHeight });
            } else if (minWidth && videoWidth < minWidth) {
              return resolve({ errmsg: '宽度不能低于' + minWidth });
            } else if (minHeight && videoHeight < minHeight) {
              return resolve({ errmsg: '高度不能低于' + minHeight });
            }
          }
          if(this.limitDuration && _videoElement.duration > Number(this.limitDuration)) {
            return resolve({ errmsg: '视频时长不能大于' + this.limitDuration });
          }
          resolve({ success: true });

          // if(_videoElement.videoHeight && _videoElement.videoWidth) {
          // const aspectRatio = this.roundNumber(_videoElement.videoWidth / _videoElement.videoHeight, 1)
          // if(this.aspectRatio == '3:4') {
          //   if(aspectRatio == 0.75 || 1) {
          //     resolve({success: true})
          //   } else {
          //     resolve({errmsg: '视频宽高比限制为3:4'})
          //   }
          // } else {
          //   if(aspectRatio > 1.5) {
          //     resolve({success: true})
          //   } else {
          //     resolve({errmsg: '视频宽高比限制为16: 9'})
          //   }
          // }
          // } else {
          //   resolve({success: true})
          // }
        });
        _videoElement.addEventListener('error', () => {
          resolve({ success: true });
        });
        _videoElement.src = URL.createObjectURL(file);
      });
    },
    roundNumber(num, decimalPlaces) {
      var multiplier = Math.pow(10, decimalPlaces);
      return Math.round(num * multiplier) / multiplier;
    },
    beforeUpload(file, fileList) {
      this.uploading = true; // 改为上传中的状态
      this._upload(file); // 将视频上传到oss
      return false;
    },
    _upload(file) {
      // 文件名限制长度（pdd）
      let filename = file.name || '';
      filename = (this.limitTitle && filename.length > this.limitTitle) ? filename.slice(filename.length - this.limitTitle, filename.length) : filename;
      const success = res => {
        this.uploading = false;
        this.errMsg = '';
        this.videoUrl = res.url;
        this.videoCover = `${res.url}?${oss_cover_search_params}`;
        this.$emit('upload-success', {
          originUrl: res.url,
          videoRatio: this.aspectRatioResult || this.aspectRatio,
          title: filename,
          videoFormat: file.type,
          videoSort: this.aspectRatio == '3:4' ? 0 : 1,
          videoCover: this.videoCover,
        });
      };
      const fail = err => {
        this.uploading = false;
        this.errMsg = '上传失败';
        return this.$message.error(this.errmsg);
      };
      const companyId = this.$store.getters.userInfo.companyId
      OSSClient.getInstance().singleUpload(`scm/${companyId}/${Date.now()}/${Math.round(Math.random()*100000)}`, file, {
        success: success,
        fail: fail,
      });
    },
    handleDel() {
      this.fileList = [];
      this.videoUrl = '';
      this.videoCover = '';
      this.$emit('del', {
        videoRatio: this.aspectRatio,
      });
    },
    handlePreview() {
      window.open(this.videoUrl);
    },
    handlePlay() {
      this.showPlayVideo = true;
    },
    closeDialog() {
      this.showPlayVideo = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.viedo-upload {
  margin-right: 10px;
  text-align: center;
}
.video-top {
  //  display: flex;
  //  align-items: center;
}
.avatar-uploader ::v-deep .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  width: 82px;
  height: 82px;
  font-size: 28px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #ccc;
}
::v-deep .el-upload-dragger{
  width: 100%;
  height: 100%;
  border: none;
}
.upload-text {
  font-size: 12px;
  margin-top: 5px;
}
.avatar {
  width: 84px;
  height: 84px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
}

.video-show {
  position: relative;
  // width: 84px;
  // height: 93px;
}
.video-mask {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 9px;
  right: 0;
  color: #ffffff;

  .del-btn {
    display: none;
    position: absolute;
    cursor: pointer;
    width: 20px;
    height: 20px;
    top: 0;
    right: 0;
    border-radius: 50%;
    transform: translate(45%, -45%);
    color: #fff;
    font-size: 12px;
    background-color: rgba(0, 0, 0, 0.4);
    text-align: center;
    line-height: 20px;
  }
  .preview-btn {
    display: none;
    position: absolute;
    cursor: pointer;
    right: 0;
    bottom: 0;
    width: 26px;
    height: 26px;
    border-top-left-radius: 6px;
    border-bottom-right-radius: 4px;
    background-color: rgba(0, 0, 0, 0.4);
    text-align: center;
    line-height: 26px;
  }
  .play-btn {
    position: absolute;
    cursor: pointer;
    top: 40px;
    right: 40px;
    transform: translate(45%, -45%);
    color: #ddd;
    font-size: 60px;
  }
}
.video-mask:hover {
  .del-btn {
    display: block;
  }
  .preview-btn {
    display: block;
  }
}
</style>